// src/frontend/components/room/UserList.jsx
import React from 'react';
import {BsPeople} from 'react-icons/bs';
import {useRoom} from '../../context/RoomContext';

export default function UserList() {
    const {users, username, leaveRoom} = useRoom();

    return (
        <div
            className="bg-white/80 dark:bg-white/5 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8 sticky top-6">
            <div className="flex items-center gap-3 mb-6">
                <BsPeople className="text-3xl text-green-500"/>
                <h2 className="text-2xl font-bold">Im Raum ({users.length})</h2>
            </div>
            <div className="space-y-4">
                {users.map((user) => (
                    <div key={user} className="flex items-center gap-3">
                        <div
                            className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold text-lg">
                            {user.charAt(0).toUpperCase() || 'A'}
                        </div>
                        <div>
                            <p className="font-semibold">{user}</p>
                            <p className="text-sm text-gray-500 dark:text-gray-400">{user === username ? 'du' : ''}</p>
                        </div>
                    </div>
                ))}
                <p className="text-center text-gray-500 dark:text-gray-400 pt-4">
                    Weitere Teilnehmer kommen bald...
                </p>
                <button
                    onClick={leaveRoom}
                    className="w-full py-4 rounded-xl bg-red-600 text-white font-bold hover:bg-red-700 transition-all duration-200"
                >
                    Raum verlassen
                </button>
            </div>
        </div>
    );
}